import styled from '@emotion/styled'

export const StyledExploreCategoryWrapper = styled.div`
  margin-bottom: 24px;
  .title {
    display: flex;
    gap: 20px;
    margin-bottom: 24px;
  }
  .see-all {
    display: inline-flex;
  }
`
